import transformBankAccountState from './transformBankAccountState';
import transformCompanyState from './transformCompanyState';
import transformContractState from './transformContractState';
import transformCustomerState from './transformCustomerState';
import transformGeneralState from './transformGeneralState';
import transformDeliveryState from './transformDeliveryState';
import transformKycState from './transformKycState';
import transformSignerState from './transformSignerState';
import transformAuthorizedRepresentatives from './transformAuthorizedRepresentatives';
import transformBeneficialOwners from './transformBeneficialOwners';
import { LeadDetailRawType } from '../../types/Lead';
import transformDocumentState from './transformDocumentState';

export default function ACL_importLeadDetails(data: LeadDetailRawType) {
    return {
        bankAccount: transformBankAccountState(data),
        company: transformCompanyState(data.customer, data.customerInstantLease),
        contract: transformContractState(data),
        customer: transformCustomerState(data),
        leadCreator: data.leadCreator,
        general: transformGeneralState(data),
        delivery: transformDeliveryState(data),
        kyc: transformKycState(data),
        signers: transformSignerState(data),
        documents: transformDocumentState(data),
        rateLimitExceeded: data.rateLimitExceeded,
        authorizedRepresentatives: transformAuthorizedRepresentatives(data.customerInstantLease),
        beneficialOwners: transformBeneficialOwners(data.customerInstantLease),
        marketingData: data.analytics.marketingCampaignData,
    };
}
